import React from 'react';
import { connect } from 'react-redux';
import CarnicaPaymentProcess from "../../widgets/SberPayment/PaymentProcess/Carnica";
import NectarPaymentProcess from "../../widgets/SberPayment/PaymentProcess/Nectar";
import { getSberPayContent, getSberPaymentStatus, getSberState } from "../../store/features/sberpay/selectors";
import { getActiveTabValue, getIsRedesign, getPaymentCtn, getUserCtn } from "../../store/common/selectors";
import { PAY_BTN_STATUSES } from "../../constants/payment";
import { sberActions } from "../../store/features/sberpay/actions";
import { findFirst } from "../../utils/arrays";
var mapStateToProps = function mapStateToProps(state) {
  return {
    stepsData: getSberPayContent(state).numberBinding,
    captchaTexts: getSberPayContent(state).captchaTexts,
    paymentSubject: getActiveTabValue(state),
    isLoading: getSberPaymentStatus(state) === PAY_BTN_STATUSES.pending,
    ctn: getPaymentCtn(state),
    initialCtn: getUserCtn(state),
    hasCaptcha: !!getSberPayContent(state).hasCaptcha,
    hasCaptchaError: getSberState(state).hasCaptchaError,
    isRedesign: !!getIsRedesign(state)
  };
};
export default connect(mapStateToProps, {
  sendSberPaymentRequest: sberActions.sberPayDataAction,
  setHasCaptchaError: sberActions.setHasCaptchaError,
  onClose: sberActions.closeProcessModalAction
})(function (props) {
  var Component = findFirst([props.isRedesign && CarnicaPaymentProcess, NectarPaymentProcess]);
  return /*#__PURE__*/React.createElement(Component, props);
});